import { useEffect } from 'react';
import { useConfig } from '../../../hooks/useConfig';
import { useSettingsService } from '../GlobalSettingsProvider';
export function useSetSettings(items, resolve, reject) {
  const {
    writeAccessState: {
      isWriteAccessDetected
    },
    dataProvider
  } = useSettingsService();
  const appName = useConfig()?.get('appName');
  useEffect(() => {
    let isMounted = true;
    async function _setSettings() {
      try {
        const response = await dataProvider.setSettings(items.map(item => ({
          ...item,
          ...(appName && {
            application: appName
          })
        })));
        if (isMounted) {
          resolve(response.items);
        }
      } catch (error) {
        if (isMounted) {
          reject();
        }
      }
    }
    if (isWriteAccessDetected && items.length > 0) {
      _setSettings();
    }
    return () => {
      isMounted = false;
    };
  }, [isWriteAccessDetected, dataProvider, items, resolve, reject, appName]);
}
//# sourceMappingURL=useSetSettings.js.map